<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'app',
  components: {
  },
}
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Kanit:300,400,600&display=swap&subset=thai');
#app {
  font-family: 'Kanit', sans-serif;
  -webkit-font-smoothing: antialiased;
}
</style>
